import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {resolveLanguage} from '@gatewee/utils/helpers/supported-languages';

@Injectable({providedIn: 'root'})
export class LanguageService {
  constructor(private translate: TranslateService) {}

  initLanguage(): void {
    const storedLang = localStorage.getItem('lang');
    const browserLang = navigator.language.split('-')[0].toLowerCase();

    const lang = resolveLanguage(storedLang, browserLang);

    this.translate.setDefaultLang(lang);
    this.translate.use(lang);
    localStorage.setItem('lang', lang);
  }
}
